let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h2YqG")).then(() => parcelRequire('7gC33'));